import cookie from 'cookie-utils-js';
import { getAppInfo } from '@/api/app';
import { capitalize } from '@/utils/util';

const resetState = {
	pageBackgroundColor: '#180f28',
	cardBackgroundColor: '#7C29C5',
	hignlightBorderColor: '#7C29C5',
	cardBtnBackgroundColor: '#382a52',
	primaryBtnBackgroundColor: '#8C33DE',
	virtualCurrencyUnit: 'gems'
};

const actions = {
	async updateAppInfo({ commit, state, rootState }, payload) {
		const appid = cookie.get('App-Id') || '1692d9cb170b471093e4922d67402264';
    const token = cookie.get('token') || '1e41ee5575df75c3ed53c5fa0f8dc7ae';

		if (!token || !appid) {
			commit('UPDATE_APP_INFO', {
				...resetState
			});
			return;
		}

		try {
			const res = await getAppInfo({
        appid,
        token
      });

			if (res.code === 0) {
				commit('UPDATE_APP_INFO', {
					pageBackgroundColor: res.data.page_background_color,
					cardBackgroundColor: res.data.card_background_color,
					hignlightBorderColor: res.data.hignlight_border_color,
					cardBtnBackgroundColor: res.data.card_btn_background_color,
					primaryBtnBackgroundColor: res.data.primary_btn_background_color,
					virtualCurrencyUnit: capitalize(res.data.virtual_currency_unit),
				});
				return;
			}

			commit('UPDATE_APP_INFO', {
				...resetState
			});
		}
		catch(err) {
			commit('UPDATE_APP_INFO', {
				...resetState
			});
		}
	},
}

export default actions;
